import {Basic} from "./Basic";
import {Display} from "./Display";

export class Lightbox
{
    constructor(image)
    {
        Basic.close_overlay('lightbox');
        this.build_lightbox();
        this.load_image(image);
    }

    build_lightbox()
    {
        this.lightboxContainer = Basic.build_overlay('lightbox');

        const lightboxInner = document.createElement('div');
        lightboxInner.classList.add('w__lightbox--inner');

        const lightboxContext = document.createElement('div');
        lightboxContext.classList.add('w__lightbox--context');

        this.mediaLegend = document.createElement('div');
        this.mediaLegend.classList.add('w__lightbox--legend');

        this.lightboxContainer.appendChild(lightboxContext);

        lightboxContext.appendChild(this.mediaLegend);
    }

    load_image(image)
    {
        // add waiting cursor
        document.documentElement.classList.add('w__waiting');

        // create image
        const src = this.adjust_imagePath(image.src, image.getAttribute('width'), image.getAttribute('height')),
              myImage = new Image;
        myImage.classList.add('w__lightbox--image');
        myImage.classList.add('w__js-button');
        myImage.src = src;
        myImage.alt = '';
        myImage.style.maxWidth = image.getAttribute('width') + 'px';
        myImage.style.maxHeight = image.getAttribute('height') + 'px';
        myImage.dataset.f = 'lightbox-close';

        myImage.addEventListener('load', () =>
        {
            // remove waiting cursor
            document.documentElement.classList.remove('w__waiting');
            let legendText = '';
            const legend =  image.nextElementSibling;
            if(legend && legend.classList.contains('w__text--image-caption'))
            {
                legendText = legend.textContent;
            }

            this.update_lightbox(myImage, legendText);
        });
    }

    update_lightbox(newMedia, legendText)
    {
        // add content
        this.lightboxContainer.appendChild(newMedia);
        this.mediaLegend.textContent = legendText;
    }

    adjust_imagePath(imgSrc, maxX, maxY)
    {
        const sizeX = Display.dpi * (Display.x - 40),
              sizeY = Display.dpi * (Display.y - 40);

        let srcPath = '/p100/',
            targetPath;

        // use y size
        if(sizeX/sizeY < maxX/maxY)
        {
            if(sizeY <= maxY * .5)
            {
                targetPath = 'p50';
            }
            else if(sizeY <= maxY * .75)
            {
                targetPath = 'p75';
            }
            else
            {
                targetPath = 'p100';
            }
        }

        // use x size
        else
        {
            if(sizeX <= maxX * .5)
            {
                targetPath = 'p50';
            }
            else if(sizeX <= maxX * .75)
            {
                targetPath = 'p75';
            }
            else
            {
                targetPath = 'p100';
            }
        }

        return imgSrc.replace(srcPath, '/' + targetPath + '/');
    }
}
